/* eslint-disable */
var BxfIconStateEnum;
(function (BxfIconStateEnum) {
    BxfIconStateEnum["primary"] = "primary";
    BxfIconStateEnum["primary-hover"] = "primary-hover";
    BxfIconStateEnum["primary-non-action"] = "primary-non-action";
    BxfIconStateEnum["secondary"] = "secondary";
    BxfIconStateEnum["secondary-active"] = "secondary-active";
    BxfIconStateEnum["non-action"] = "non-action";
    BxfIconStateEnum["boxed"] = "boxed";
    BxfIconStateEnum["boxed-hover"] = "boxed-hover";
    BxfIconStateEnum["success"] = "success";
    BxfIconStateEnum["success-subtle"] = "success-subtle";
    BxfIconStateEnum["gain"] = "success";
    BxfIconStateEnum["success-alternate"] = "success-alternate";
    BxfIconStateEnum["error"] = "error";
    BxfIconStateEnum["error-subtle"] = "error-subtle";
    BxfIconStateEnum["loss"] = "error";
    BxfIconStateEnum["alert"] = "alert";
    BxfIconStateEnum["alert-subtle"] = "alert-subtle";
    BxfIconStateEnum["warning"] = "warning";
    BxfIconStateEnum["warning-subtle"] = "warning-subtle";
    BxfIconStateEnum["informational"] = "informational";
    BxfIconStateEnum["informational-subtle"] = "informational-subtle";
    BxfIconStateEnum["new"] = "new";
    BxfIconStateEnum["new-subtle"] = "new-subtle";
    BxfIconStateEnum["attention"] = "new";
    BxfIconStateEnum["checkbox"] = "checkbox";
    BxfIconStateEnum["neutral"] = "neutral";
    BxfIconStateEnum["neutral-subtle"] = "neutral-subtle";
    BxfIconStateEnum["bxf-button"] = "bxf-button";
    BxfIconStateEnum["primary-button"] = "primary-button";
    BxfIconStateEnum["primary-button-hover"] = "primary-button-hover";
    BxfIconStateEnum["primary-button-active"] = "primary-button-active";
    BxfIconStateEnum["secondary-button"] = "secondary-button";
    BxfIconStateEnum["secondary-button-hover"] = "secondary-button-hover";
    BxfIconStateEnum["secondary-button-active"] = "secondary-button-active";
    BxfIconStateEnum["tertiary-button"] = "tertiary-button";
    BxfIconStateEnum["tertiary-button-hover"] = "tertiary-button-hover";
    BxfIconStateEnum["tertiary-button-active"] = "tertiary-button-active";
    BxfIconStateEnum["tertiary_alt-button"] = "tertiary_alt-button";
    BxfIconStateEnum["tertiary_alt-button-hover"] = "tertiary_alt-button-hover";
    BxfIconStateEnum["tertiary_alt-button-active"] = "tertiary_alt-button-active";
    BxfIconStateEnum["tertiary-subtle-button"] = "tertiary-subtle-button";
    BxfIconStateEnum["tertiary-subtle-button-hover"] = "tertiary-subtle-button-hover";
    BxfIconStateEnum["tertiary-button--active"] = "tertiary-button--active";
    BxfIconStateEnum["tertiary-button--active-hover"] = "tertiary-button--active-hover";
    BxfIconStateEnum["tertiary-button--active-active"] = "tertiary-button--active-active";
    BxfIconStateEnum["tertiary-subtle-button-active"] = "tertiary-subtle-button-active";
    BxfIconStateEnum["destructive-primary-button"] = "destructive-primary-button";
    BxfIconStateEnum["destructive-primary-button-hover"] = "destructive-primary-button-hover";
    BxfIconStateEnum["destructive-primary-button-active"] = "destructive-primary-button-active";
    BxfIconStateEnum["destructive-secondary-button"] = "destructive-secondary-button";
    BxfIconStateEnum["destructive-secondary-button-hover"] = "destructive-secondary-button-hover";
    BxfIconStateEnum["destructive-secondary-button-active"] = "destructive-secondary-button-active";
    BxfIconStateEnum["destructive-tertiary-button"] = "destructive-tertiary-button";
    BxfIconStateEnum["destructive-tertiary-button-hover"] = "destructive-tertiary-button-hover";
    BxfIconStateEnum["destructive-tertiary-button-active"] = "destructive-tertiary-button-active";
    BxfIconStateEnum["affirmative-primary-button"] = "affirmative-primary-button";
    BxfIconStateEnum["affirmative-primary-button-hover"] = "affirmative-primary-button-hover";
    BxfIconStateEnum["affirmative-primary-button-active"] = "affirmative-primary-button-active";
    BxfIconStateEnum["affirmative-secondary-button"] = "affirmative-secondary-button";
    BxfIconStateEnum["affirmative-secondary-button-hover"] = "affirmative-secondary-button-hover";
    BxfIconStateEnum["affirmative-secondary-button-active"] = "affirmative-secondary-button-active";
    BxfIconStateEnum["affirmative-tertiary-button"] = "affirmative-tertiary-button";
    BxfIconStateEnum["affirmative-tertiary-button-hover"] = "affirmative-tertiary-button-hover";
    BxfIconStateEnum["affirmative-tertiary-button-active"] = "affirmative-tertiary-button-active";
    BxfIconStateEnum["underline"] = "underline";
    BxfIconStateEnum["underline-hover"] = "underline-hover";
})(BxfIconStateEnum || (BxfIconStateEnum = {}));

export { BxfIconStateEnum as B };
